// Reversible feature flags.
//
// TRIAL_ENABLED — the trial-STUDENT feature ("Website Requests": public "Book a Free
// Trial" enquiry + admin/trainer intake pipeline). Set to `false` to HIDE every
// trial-student entry point (public CTAs, /:clubSlug/trial route, Website Requests
// nav/dashboard cards). Flip back to `true` to restore everything — models, pages and
// controllers are kept dormant, not deleted.
//
// NOTE: this is unrelated to the SaaS *subscription* trial (a club's 14-day free trial,
// TrialBanner / subscription reminders / checkSubscription) — that feature is separate
// and unaffected by this flag.
export const TRIAL_ENABLED = false;

// APPROVALS_ENABLED — the member-approval / self-signup surface. When `false` the app is
// INVITE-ONLY: every Approvals entry point is hidden (nav item, route, dashboard cards)
// and the public /:clubSlug/join self-signup route is not rendered. Flip back to `true`
// to restore the Approvals page and self-signup UI. The backend FORCE_INVITE_ONLY flag
// (authController) is the real guarantee that no pending user can be created; keep the two
// in sync. Email-invite, login and the convert/record-only flows are unaffected either way.
export const APPROVALS_ENABLED = false;
